import packageJson from '../../package.json';

export const environment = {
  production: false,
  apiUri: "https://wifi-qa.plusmore.co.za/api",
  version: packageJson.version,
};
